export default function getProfileSettings() {
  let settings;
  if (localStorage.getItem('profileSettings') !== null) {
    settings = JSON.parse(localStorage.getItem('profileSettings'));
  } else {
    localStorage.setItem(
      'profileSettings',
      JSON.stringify({ displayMode: 'grid' }),
    );
    settings = { displayMode: 'grid' };
  }
  console.log(settings);
  return settings;
}
